<div class="flex flex-col gap-1 w-full animate-fade-in p-4">
  <app-header
    title="Tenant Management"
    searchPlaceholder="Search tenants..."
    newButtonTooltip="New Tenant"
    [showFilter]="false"
    (onSearch)="handleSearch($event)"
    (onNewClick)="openTenantModal()"
  ></app-header>

  <app-table
    [allData]="tableData"
    [columns]="tableColumns"
    [actions]="tableActions"
    [totalRecords]="totalRecords"
    [loading]="loading"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50]"
    (onLazyLoad)="loadTenantsLazy($event)"
  >
  </app-table>
</div>